import {
  useCheckPermissionsArray,
  useTableFilter,
  useTableServerSideFiltering,
} from "@/shared/hooks";
import GeneralTable from "@/shared/components/ui/GeneralTable";
import { IReporteVentaCorporativaParams } from "@/shared/interfaces";
import { Grid, IconButton, Tooltip } from "@mui/material";
import { PermissionsEnum } from "@/auth/interfaces";
import { EstadoProspectoEnum, ROUTER_PATHS, TABLE_CONSTANTS } from "@/shared";

import { useNavigate } from "react-router-dom";
import { useColumnsEstadoPreventaCorporativa } from "./columns/useColumnsEstadoPreventaCorporativa";
import { useFetchReporteGeneralCorporativo } from "@/shared/actions/erp/reporte-venta-corporativa.actions";
import InfoCoordendas from "@/shared/components/ui/InfoCoordendas/InfoCoordendas";
import { Timeline } from "@mui/icons-material";

interface TableEstadoVentaCorporativoProps {
  showCustomActionBtnSpace?: boolean;
  estado_prospecto?: EstadoProspectoEnum;
  estado_prospecto_exclude?: EstadoProspectoEnum;
}

export default function TableEstadoVentaCorporativo({
  estado_prospecto = undefined,
  estado_prospecto_exclude = undefined,
}: TableEstadoVentaCorporativoProps) {
  useCheckPermissionsArray([
    PermissionsEnum.api_view_preventacoorporativa,
    PermissionsEnum.api_change_preventacoorporativa,
  ]);

  ///* Hook
  const { columnsEstadoVentaCorporativo } =
    useColumnsEstadoPreventaCorporativa();
  const navigate = useNavigate();
  ///* Hook

  const { pagination, setPagination } = useTableFilter();

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { pageIndex, pageSize } = pagination;
  ///* Fetch

  const {
    isLoading,
    data: dataTrazoCorporativo,
    isRefetching,
  } = useFetchReporteGeneralCorporativo({
    page: pageIndex + 1,
    page_size: pageSize,
    ...filterObject,
    filterByState: false,
    [estado_prospecto ? "estado_prospecto" : ""]: [
      estado_prospecto ? estado_prospecto : "",
    ],
    [estado_prospecto_exclude ? "estado_prospecto_exclude" : ""]: [
      estado_prospecto_exclude ? estado_prospecto_exclude : "",
    ],
  });

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}></Grid>
        <Grid item xs={12}>
          <GeneralTable<IReporteVentaCorporativaParams>
            columns={columnsEstadoVentaCorporativo}
            data={dataTrazoCorporativo?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={dataTrazoCorporativo?.data?.count}
            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}
            // // actions
            // crud
            canDelete={false}
            canEdit={false}
            positionActionsColumn="first"
            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_MEDIUM}
            enableEditing={true}
            showCustomActionBtnSpace={true}
            customActionBtnSpace={(value) => {
              // Obtener la primera factibilidad del prospecto (si existe)
              const factibilidad = value.factibilidad_corporativa_data?.[0];
              if (!factibilidad) return null;

              return (
                <Grid container spacing={1}>
                  <Grid item>
                    <Tooltip placement="top" title="Ver Trazabilidad">
                      <IconButton
                        color="primary"
                        onClick={() => {
                          navigate(
                            `${ROUTER_PATHS.noc.trazabilidadFactibilidadCorporativoNav}/${factibilidad.id_factibilidad_coorporativa}?from=estado-venta`,
                          );
                        }}
                      >
                        <Timeline />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>
              );
            }}
          />
        </Grid>
        <InfoCoordendas />
      </Grid>
    </>
  );
}
